import React, { useContext } from 'react'
import { graphql, useStaticQuery } from "gatsby"
import Reactmarkdown from "react-markdown/with-html"
import { Container, Accordion, Card } from "react-bootstrap"
import AccordionContext from 'react-bootstrap/AccordionContext';
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';
import scrollTo from "gatsby-plugin-smoothscroll"


const query = graphql`
{
  allStrapiFaqs {
    nodes {
      title
      question {
        title
        id
        content
      }
    }
  }
}`

function ContextAwareToggle({ children, eventKey, callback }) {
  const currentEventKey = useContext(AccordionContext);

  const decoratedOnClick = useAccordionToggle(
    eventKey,
    () => callback && callback(eventKey)
  )

  const handleClick = (e) => {
    const link = e.currentTarget.parentNode;
    decoratedOnClick();
    setTimeout(
      function () {
        scrollTo(`#${link.id}`)
      },
      500
    )
      
  }

  const isCurrentEventKey = currentEventKey === eventKey;
    return (
      <div className={`py-3 py-xl-4 section-header`} id={eventKey}>
        <button onClick={handleClick} className="w-100 button-blank">
          <h2>
          {children}
          {isCurrentEventKey ? <span className="icon-arr-up"></span>  : <span className="icon-arr-down"></span>}
          </h2> 
        </button>
      </div>
  );
}


const Faq = () => {
    
    const { allStrapiFaqs: { nodes: pytania } } = useStaticQuery(query);
    
        return (
        <section className="faq py-5 mb-xl-5" id="faq">
        <Container>
            <h2 className="text-center mb-5 font-light section-title">FAQ</h2>
            <Accordion defaultActiveKey="card-0">
                {pytania.map((pytanie,i) => {
                    return (
                        <Card key={i} bsPrefix=" ">
                            <ContextAwareToggle eventKey={`card-${i}`}>
                               {pytanie.title}
                            </ContextAwareToggle>
                            <Accordion.Collapse eventKey={`card-${i}`}>
                            <Card.Body className="col-md-10 ml-auto mb-4" bsPrefix=" ">
                                    {pytanie.question.map((sub,i) => {
                                        return (
                                            <div key={sub.id} className="sub-question py-2 py-md-3 py-xl-4">
                                                <h3>{sub.title}</h3>
                                                <Reactmarkdown source={sub.content} escapeHtml={false} />
                                            </div>
                                            )
                                    })}
                            </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    )
                })}
            </Accordion>
        </Container>
        </section>

    )
}

export default Faq
